/* Extend the collection artwork behind navigation and announcement. */
(() => {
  const banner = document.querySelector('.saam-collection-header');
  const header = document.querySelector('.section-header');
  if (!banner || !header) return;
  const headerSections = [...document.querySelectorAll('.shopify-section-group-header-group')];
  const measure = () => banner.style.setProperty('--saam-collection-nav-height', `${headerSections.reduce((height, section) => height + section.getBoundingClientRect().height, 0)}px`);
  measure();
  const observer = new ResizeObserver(measure);
  headerSections.forEach(section => observer.observe(section));
})();
